import React from 'react';
import {t} from '@lingui/core/macro';

import {ILocation} from 'entities/location';

import AdminFormModal, {IAdminEntityModalProps} from '../AdminList/AdminFormModal';
import LocationsForm from './LocationsForm';

const LocationsModal: React.FC<IAdminEntityModalProps<ILocation>> = (props) => (
    <AdminFormModal {...props} addHeader={t`Добавить локацию`} editHeader={t`Изменить локацию`} Form={LocationsForm}/>
);

export default LocationsModal;
